import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';

// @dynamic-i18n-keys
// common.stats.*

const getStatLine = (
  t: (key: string, options?: Record<string, unknown>) => string,
  entity: string,
  count?: number
) => {
  const formattedCount = count && shortenNumber(count);
  return count
    ? t(`common.stats.${entity}`, {
        count,
        formattedCount,
      })
    : '';
};

export default getStatLine;
